"use client";

import { useState } from "react";
const styles = new Proxy({"Wrapper":"Wrapper-807f4","Grid":"Grid-807f4","AccordionList":"AccordionList-807f4","AccordionItem":"AccordionItem-807f4","AccordionHeader":"AccordionHeader-807f4","AccordionIcon":"AccordionIcon-807f4","AccordionItemOpen":"AccordionItemOpen-807f4","AccordionTitle":"AccordionTitle-807f4","AccordionBody":"AccordionBody-807f4","AccordionBodyInner":"AccordionBodyInner-807f4","Card":"Card-807f4","Title":"Title-807f4","Heading":"Heading-807f4","SectionTitle":"SectionTitle-807f4","Subtitle":"Subtitle-807f4","BulletpointHeading":"BulletpointHeading-807f4","CtaWrapper":"CtaWrapper-807f4","CtaButton":"CtaButton-807f4","List":"List-807f4"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
import { RichText } from "payload-pms/RichText";
import { SerializedEditorState } from "@payloadcms/richtext-lexical/lexical";

interface Card {
  title: string;
  bulletpointHeading?: string;
  content?: SerializedEditorState;
  ctaUrl?: string;
  ctaLabel?: string;
}

export default function CTACardBulletpointsAccordion({
  cards,
}: {
  cards: Card[];
}) {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className={styles.AccordionList}>
      {cards.map((card, idx) => {
        const isOpen = idx === openIndex;
        return (
          <div
            key={idx}
            className={`${styles.AccordionItem} ${isOpen ? styles.AccordionItemOpen : ""}`}
          >
            <button
              className={styles.AccordionHeader}
              onClick={() => setOpenIndex(idx)}
              aria-expanded={isOpen}
            >
              <span className={styles.AccordionIcon}>{isOpen ? "−" : "+"}</span>
              <span className={styles.AccordionTitle}>{card.title}</span>
            </button>
            <div className={styles.AccordionBody}>
              <div className={styles.AccordionBodyInner}>
                {card.bulletpointHeading && (
                  <p className={styles.BulletpointHeading}>
                    {card.bulletpointHeading}
                  </p>
                )}
                {card.content && (
                  <div className={styles.List}>
                    <RichText content={card.content} />
                  </div>
                )}
                <div className={styles.CtaWrapper}>
                  <a
                    href={card.ctaUrl || "#"}
                    className={styles.CtaButton}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {card.ctaLabel || "Learn more"}
                  </a>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
